/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Destination_UnknownInputs */

const fr_marker_destination_unknown = /** @type {(inputs: Marker_Destination_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destination inconnue`)
};

const en_marker_destination_unknown = /** @type {(inputs: Marker_Destination_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown destination`)
};

/**
* | output |
* | --- |
* | "Unknown destination" |
*
* @param {Marker_Destination_UnknownInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_destination_unknown = /** @type {((inputs?: Marker_Destination_UnknownInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Destination_UnknownInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_destination_unknown(inputs)
	return en_marker_destination_unknown(inputs)
});